import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Kanton } from '@entity/kanton';
import { MainDataService } from '@service/main-data.service';

export const KantoneResolve: ResolveFn<Kanton[]> = () => {
  return inject(MainDataService).getKantone();
};
